"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Sealed = exports.Enumerable = void 0;
require("reflect-metadata");
function Enumerable(value) {
    return (target, propertyKey, descriptor) => {
        descriptor.enumerable = value;
    };
}
exports.Enumerable = Enumerable;
function Sealed() {
    return (constructor) => {
        Object.seal(constructor);
        Object.seal(constructor.prototype);
    };
}
exports.Sealed = Sealed;
